import React from "react";

const ColorModeContext = React.createContext({
  toggleColorMode: () => {},
  setThemeMode: () => {},
  themePreference: "system",
});

export default ColorModeContext;